import React, { useState } from 'react'
import HybridLayout from './HybridLayout'
import { FieldValues } from 'react-hook-form'
import { FormHeader } from '../../pages/AddEditViewRecord.page'
import { useLocation, useNavigate } from 'react-router-dom'
import { isEntityEditRoute } from '../../utils/maxRTE'
import { useDispatch } from 'react-redux'
import { editEntityData } from '../../apis/entityData.api'
import { addToaster, LayoutResponseType } from '@app-store'
import { TOASTER_NAMESPACE } from '../../constants/addEditPage.strings'
import { v4 as uuid } from 'uuid'
import { entitiesRoute } from '../../routes/route.constant'
import { ConfirmDialog } from '@ui-kit'
import { NAMESPACES } from '../../utils/constants'
import { removeCheckAttachKeyFromSession } from '../../utils/dynamic-queue'
import { HybridLayoutIntakeWrapperProps } from './hybridLayout.types'
import { EntityLayout } from '../../types/layout.types'

export const HybridLayoutIntakeWrapper: React.FC<
  HybridLayoutIntakeWrapperProps
> = (props) => {
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [modalOpen, setModalOpen] = useState<boolean>(false)

  const handleSave = async (data: FieldValues) => {
    try {
      const layout_data = props?.layoutData
      if (
        layout_data?.entity_name &&
        layout_data?.entity_id &&
        layout_data?.id
      ) {
        const res = await editEntityData(
          layout_data?.entity_name ?? '',
          layout_data?.entity_id ?? 0,
          layout_data?.id ?? 0,
          data,
          props?.id ?? ''
        )
        dispatch(
          addToaster({
            message: TOASTER_NAMESPACE.EDIT_SUCCESS,
            type: 'success',
            id: uuid(),
          })
        )
        props?.allowNavigate &&
          navigate(`/${entitiesRoute}/${layout_data?.entity_id}`)
        props?.onSaveClick?.(undefined, res?.data?.id)
      }
    } catch (err) {
      console.error(err)
    }
  }
  return (
    <React.Fragment>
      <ConfirmDialog
        open={modalOpen}
        message={NAMESPACES.CONFIRM_CANCEL}
        onCancel={() => setModalOpen(false)}
        onConfirm={() => {
          props?.allowNavigate && navigate(-1)
          props?.onCancel && props?.onCancel()
          setModalOpen(false)
          if (props?.isAttachCase) {
            removeCheckAttachKeyFromSession()
          }
        }}
      />
      <HybridLayout
        {...props}
        formHeaders={
          <FormHeader
            mode={props?.mode}
            data={[props?.layoutData] as EntityLayout[]}
            shouldModalOpen={true}
            allowNavigate={props?.allowNavigate ?? true}
            entityId={props?.entityId}
            isAttachCase={props?.isAttachCase ?? false}
            id={props?.id}
            isFormDirty={true}
            showButtonsInView={props?.showButtonsInView}
            showFooter={props?.showFooter ?? false}
            showDraftInAdd={true}
            setModalOpen={setModalOpen}
            onCancel={props?.onCancel}
            onAttachClick={props?.onAttachClick}
            onEditClick={props?.onEditClick}
            onSaveButtonClick={props?.onIntakeHeaderSave}
            onCancelButtonClick={props?.onIntakeHeaderCancel}
            shouldRedirectOnEditWhenSensitive={
              props?.shouldRedirectOnEditWhenSensitive
            }
            showCheckEligibiltiy={isEntityEditRoute(pathname)}
            onEditClickInViewLayout={props?.onEditClickInViewLayout}
          />
        }
        layoutData={props?.layoutData as LayoutResponseType}
        handleFormSubmit={handleSave}
        openAllAccordions={true}
      />
    </React.Fragment>
  )
}
